import {AfterViewInit, Directive, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';

@Directive({
  selector: '.btn.btn-hero.btn-hero-toggle', // class selector
  standalone: true,
})
export class HeroButtonToggleDirective implements AfterViewInit {
  private _state: boolean = false; // Private backing field for state

  @Input('checked')
  set state(value: boolean) {
    this._state = value ?? false; // Handle undefined/null
    this.updateButtonAppearance(); // Reflect state changes from parent
  }

  get state(): boolean {
    return this._state;
  }

  private _disabled: boolean = false; // Private backing field for disabled

  @Input('disabled')
  set disabled(value: boolean | string) {
    this._disabled = value === '' ? true : !!value; // Handle undefined/null
    this.updateButtonAppearance();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Output('checkedChange') stateChange = new EventEmitter<boolean>(); // For two-way binding

  private buttonContainer: HTMLDivElement | null = null;

  constructor(
    private el: ElementRef<HTMLButtonElement>, // HTMLButtonElement !!!!!!!!!
    private renderer: Renderer2
  ) {
  }

  ngAfterViewInit(): void {
    this.buildDomStructure();
    this.updateButtonAppearance(); // Apply initial state
    this.setupClickHandler();
  }

  private buildDomStructure(): void {

    const button = this.el.nativeElement;
    const parent = button.parentElement;
    const nextSibling = button.nextSibling;

    const wrapperDiv = this.renderer.createElement('div');
    this.renderer.addClass(wrapperDiv, 'btn-hero-wrapper');

    // this is the toggle container
    this.buttonContainer = this.renderer.createElement('div');
    this.renderer.addClass(this.buttonContainer, 'btn-hero-toggle-container');
    // this is the slider element
    const sliderSpan = this.renderer.createElement('span');
    this.renderer.addClass(sliderSpan, 'btn-hero-toggle-slider');

    this.renderer.appendChild(wrapperDiv, button);
    this.renderer.appendChild(this.buttonContainer, sliderSpan);

    this.renderer.appendChild(wrapperDiv, this.buttonContainer);

    if (parent) {
      if (nextSibling) {
        this.renderer.insertBefore(parent, wrapperDiv, nextSibling);
      } else {
        this.renderer.appendChild(parent, wrapperDiv);
      }
    } else {
      console.warn('HeroButtonToggleDirective: No parent element found for wrapping.');
    }
  }

  private setupClickHandler(): void {
    this.renderer.listen(this.buttonContainer, 'click', () => {
      this.toggleState();
    });
  }

  private toggleState(): void {
    if (this._disabled) return; // Do nothing
    this._state = !this._state; // Toggle the state
    this.updateButtonAppearance(); // Update visuals
    this.stateChange.emit(this._state); // Emit new state
    this.el.nativeElement.click(); // Keep focus on button
  }

  private updateButtonAppearance(): void {
    if (!this.buttonContainer) return; // Do nothing

    if (this._state) {
      this.renderer.addClass(this.buttonContainer, 'active');
    } else {
      this.renderer.removeClass(this.buttonContainer, 'active');
    }
    if (this._disabled) {
      this.renderer.addClass(this.buttonContainer, 'disabled');
    } else {
      this.renderer.removeClass(this.buttonContainer, 'disabled');
    }
  }
}
